import { Component, OnInit, Input } from '@angular/core'
import { TrainingModel } from '../../models/training-model'

@Component({
    selector: 'training-courses-list',
    templateUrl: './training-courses-list.component.html',
    styleUrls: ['./training-courses-list.component.scss']

})
export class TrainingCoursesList implements OnInit {
    @Input("courses") courses: TrainingModel[];
    ngOnInit() { }
}